import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow
} from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { ProductThumb } from '../../../../components/advertiserBrand/ProductThumb'
import styles from '../../../../components/advertiserBrand/styles.module.css'
import { Chip } from './Chip'
import { ReviewRow, statusLabelKey } from './reviewRows'

// produto · marca · status — a marca cresce com o nome, com teto em `.brandCell`
const REVIEW_COLUMN_WIDTHS = [
  'minmax(0, 1fr)',
  'minmax(12.5rem, max-content)',
  '14rem'
]

export const ReviewTable: React.FC<{ rows: ReviewRow[] }> = ({ rows }) => {
  const { t } = useAPPTranslation()

  return (
    <Table columnWidths={REVIEW_COLUMN_WIDTHS}>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>
            {t('rm:advertiserProducts.table.column.product')}
          </TableHeaderCell>
          <TableHeaderCell>
            {t('rm:advertiserProducts.table.column.brand')}
          </TableHeaderCell>
          <TableHeaderCell>
            {t('rm:advertiserProducts.import.review.column.status')}
          </TableHeaderCell>
        </TableRow>
      </TableHeader>

      <TableBody>
        {rows.map(row => (
          <TableRow
            key={row.id}
            className={
              row.status === 'error' ? styles.reviewRowError : undefined
            }
          >
            <TableCell>
              <span className={styles.productCell}>
                <ProductThumb url={row.image_url} />
                <span className={styles.productText}>
                  <span className={styles.productName}>{row.name}</span>
                  <span className={styles.productMeta}>
                    EAN:{row.gtin || '—'}
                  </span>
                </span>
              </span>
            </TableCell>
            <TableCell>
              <span className={`${styles.brandText} ${styles.brandCell}`}>
                <span className={styles.brandName}>{row.brand || '—'}</span>
                {row.status === 'move' && (
                  <span className={styles.brandMeta}>
                    {t('rm:advertiserProducts.import.review.currentBrand', {
                      brand: row.current_brand
                    })}
                  </span>
                )}
              </span>
            </TableCell>
            <TableCell>
              <Chip
                tone={row.status}
                label={t(statusLabelKey(row.status, row.code))}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
